import { api } from "..";
import { BroadcastMessagesPayload, BroadcastMessagesResponse } from "./types";

export const broadcastMessages = async (
  payload: BroadcastMessagesPayload
): Promise<BroadcastMessagesResponse> => {
  const res = await api.client.post("/chats/messages/broadcast", payload);
  return res.data;
};
